export const getSeasonImage = (season) => {
  switch (season) {
    case "OPTIMAL":
      return {
        iconName: "summer",
      };
    case "ISOLENT":
      return {
        iconName: "fall",
      };
    case "ISOMAX":
      return {
        iconName: "winter",
      };

    default:
      console.error("getSeasonImage: Could not find the provided season");
      return;
  }
};
